"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSLookupOrderComponent = void 0;
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const orderStatus_service_1 = require("../../services/orderStatus.service");
const constants = require("../../util/constants");
class CSLookupOrderComponent {
    constructor(orderService, router, modalService) {
        this.orderService = orderService;
        this.router = router;
        this.modalService = modalService;
    }
    ngOnInit() {
        this.orderService.validateSSN({ validateSSN: false })
            .subscribe((res) => {
        });
        this.ordernumber = '';
    }
    getOrderDetails(orderId) {
        this.loader = true;
        this.orderService.getOrderDetails(orderId, this.zipcode, false)
            .subscribe((res) => {
            this.loader = false;
            if (res) {
                this.orderService.orderData = res.orderDetails[0];
                if (!this.orderService.orderData) {
                    this.error = this.setErrorMessage(constants.orderNotFound);
                }
                else {
                    this.router.navigate(['/details']);
                }
            }
            else {
                this.error = this.setErrorMessage(constants.orderNotFound);
            }
        }, (err) => {
            var _a, _b;
            if ((_a = err === null || err === void 0 ? void 0 : err.error) === null || _a === void 0 ? void 0 : _a.message) {
                err = this.setErrorMessage((_b = err === null || err === void 0 ? void 0 : err.error) === null || _b === void 0 ? void 0 : _b.message);
            }
            this.error = err;
            this.loader = false;
        });
    }
    getPreOrderDetails(orderId) {
        this.loader = true;
        this.orderService.getPreOrderDetails(orderId, null)
            .subscribe((preOrderDetails) => {
            this.loader = false;
            if (preOrderDetails) {
                this.orderService.preOrderData = preOrderDetails[0];
                if (!this.orderService.preOrderData) {
                    this.error = this.setErrorMessage(constants.orderNotFound);
                }
                else {
                    this.router.navigate(['/preorder-details']);
                }
            }
            else {
                this.error = this.setErrorMessage(constants.orderNotFound);
            }
        }, (err) => {
            var _a, _b;
            if ((_a = err === null || err === void 0 ? void 0 : err.error) === null || _a === void 0 ? void 0 : _a.message) {
                err = this.setErrorMessage((_b = err === null || err === void 0 ? void 0 : err.error) === null || _b === void 0 ? void 0 : _b.message);
            }
            this.error = err;
            this.loader = false;
        });
    }
    checkStatus(ordernumber) {
        if (ordernumber.length === 8) {
            this.getPreOrderDetails(ordernumber);
        }
        else if (ordernumber.length === 10) {
            this.getOrderDetails(ordernumber);
        }
    }
    /**
     * @returns open find this number poup
     */
    findOrderNumberPopup(content) {
        this.modelRef = this.modalService.open(content, { size: 'lg', centered: true });
    }
    setErrorMessage(errorMessage) {
        const errorMsg = {
            errorMessage
        };
        return errorMsg;
    }
    // Clears Zip code value
    clearZipcode(length) {
        if (length === 8) {
            this.zipcode = '';
        }
    }
}
exports.CSLookupOrderComponent = CSLookupOrderComponent;
//# sourceMappingURL=orderlookup.component.js.map